"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButton = void 0;
const react_1 = __importStar(require("react"));
const colors_1 = require("../../../theme/colors");
const icons_1 = require("../../../theme/icons");
const ActionButton_styles_1 = require("./ActionButton.styles");
const ActionButton = ({ label, onClick, buttonType: typeFromProps, active, icon: Icon, arrangement: arrangementFromProps, openOnHover, onHover, }) => {
    const [hover, setHover] = (0, react_1.useState)(false);
    const getColor = (type, hover, active) => {
        if (type === "cta") {
            return colors_1.WHITE;
        }
        else if (type === "hamburger") {
            return colors_1.GREY4;
        }
        else if (hover || active) {
            return colors_1.DARK_GREEN;
        }
        return colors_1.GREY4;
    };
    const onMouseHoverEnter = () => {
        if (openOnHover && onHover) {
            onHover();
        }
        setHover(true);
    };
    const onMouseHoverLeave = () => {
        setHover(false);
    };
    const type = typeFromProps !== null && typeFromProps !== void 0 ? typeFromProps : "cta";
    const arrangement = arrangementFromProps !== null && arrangementFromProps !== void 0 ? arrangementFromProps : "fitContent";
    const color = getColor(type, hover, active);
    return (react_1.default.createElement(ActionButton_styles_1.ActionButtonStyle, { "$type": type, onClick: onClick, "$active": !!active, "$arrangement": arrangement, onMouseEnter: onMouseHoverEnter, onMouseLeave: onMouseHoverLeave },
        Icon && react_1.default.createElement(ActionButton_styles_1.IconWrapper, { "$type": type }, react_1.default.createElement(Icon, { color: color })),
        type !== "hamburger" && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ActionButton_styles_1.Label, { "$arrangement": arrangement, "$active": !!active, "$type": type }, label),
            react_1.default.createElement(ActionButton_styles_1.DropDownWrapper, { "$arrangement": arrangement },
                react_1.default.createElement(icons_1.ArrowDropDown, { color: type === "cta" ? colors_1.WHITE : colors_1.GREY4 }))))));
};
exports.ActionButton = ActionButton;
//# sourceMappingURL=ActionButton.js.map